import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { Kaizen } from './kaizen';
import { KaizenService } from './kaizen.service';
import { ConfirmDialogDeleteService } from '../Services/confirm-dialog-delete.service';
import { Router } from '@angular/router';
import { ProfileClaims } from '../models/ProfileClaims';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { LoaderService } from '../loader/loader.service';
import { KaizenDashboard } from './kaizenDashboard';
import { PageEvent } from '@angular/material/paginator';
import { finalize } from 'rxjs';
@Component({
    selector: 'app-kaizens',
    templateUrl: './kaizens.component.html',
    styleUrls: ['./kaizens.component.css'],
    standalone: false
})
export class KaizensComponent implements OnInit, AfterViewInit {

  kaizens: Kaizen[] = [];
  dataSource = new MatTableDataSource<KaizenDashboard>();
  displayedColumns: string[] = [
    'kaizenNumber', 'company', 'line', 'shop', 'name', 'account',
    'fySavings', 'internalTrackingNo', 'trackingRef1', 'trackingRef2', 'state', 'action'
  ];
  showHidden: boolean = false;
  showHiddenLabel: string = 'No';
  firstFormGroup!: UntypedFormGroup;
  pageNumber = 1;
  pageSize = 25;
  totalItems = 0;
  selectedKaizen?: Kaizen;
  public profileClaim?: ProfileClaims;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(
    private kaizenService: KaizenService,
    private dialogdeletekaizen: ConfirmDialogDeleteService,
    private formBuilder: UntypedFormBuilder,
    public loaderService: LoaderService,
    private router: Router
  ) { }

  header = 'Regional Kaizen system';

  ngOnInit(): void {
    this.profileClaim = JSON.parse(localStorage.getItem(`profileClaims`)!);
    this.firstFormGroup = this.formBuilder.group({
      showHiddenKaizens: [''],
    });

    this.getKaizens(this.pageNumber, this.pageSize);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.sort.sortChange.subscribe(() => {
      this.pageNumber = 1; 
    });
  }

  DeleteKaizen(kaizenId: number) {
    this.dialogdeletekaizen.openDialog().afterClosed().subscribe(res => {
      if (res) {
        firstValueFrom(this.kaizenService.delKaizen(kaizenId)).then(() => {
          this.router.navigate(['/kaizens'])
            .then(() => {
              window.location.reload();
            });
        });
      }
    });
  }

  private mapToTableView(data: Kaizen[]): KaizenDashboard[] {
    return data.map(k => ({
      kaizenId: k.kaizenId,
      company: k.company,
      shop: k.shop,
      line: k.line,
      name: k.name,
      account: k.account,
      tags: k.tags,
      fySavings: k.fySavings,
      costMeasure: k.costMeasure,
      state: k.state.toString(),
      kaizenCreator: k.kaizenCreator,
      kaizenCreatorId: k.kaizenCreatorId,
      createdAt: k.createdAt,
      kaizenNumber: k.kaizenNumber,
      posted: k.posted,
      version: k.version,
      updatedOn: k.updatedOn,
      hidden: k.hidden,
      internalTrackingNo: k.internalTrackingNo,
      trackingRef1: k.trackingRef1,
      trackingRef2: k.trackingRef2
    }));
  }

getKaizens(pageNumber: number, pageSize: number): void {
  this.loaderService.isLoading.next(true);

  this.kaizenService.getKaizensExcludeHiddenPaged(pageNumber, pageSize)
    .pipe(
      finalize(() => this.loaderService.isLoading.next(false))
    )
    .subscribe({
      next: (data) => {
        this.totalItems = data.totalCount;
        this.dataSource.data = this.mapToTableView(data.data);

        if (this.paginator) {
          this.paginator.pageIndex = this.pageNumber - 1;
        }
      },
      error: (error) => console.error(error)
    });
}
  onPageChange(event: PageEvent) {
    this.pageNumber = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.getKaizens(this.pageNumber, this.pageSize);
  }
  
  shopSizer(shopname: string): string {
    if (shopname.length > 15) {
      return shopname.substring(0, 15) + '...';
    }
    return shopname;
  }

  showHiddenKaizensChange(e: any) {
    this.pageNumber = 1;
    this.showHidden = e.target.checked;
    if (this.showHidden) {
      this.showHiddenLabel = 'Yes';
      this.kaizenService.getKaizens().subscribe({
        next: (data) => {
          this.kaizens = data.data;
          this.dataSource.data = this.mapToTableView(data.data);
          if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
          }
        },
        error: (error) => console.info(error)
      });
    } else {
      this.showHiddenLabel = 'No';
      this.kaizenService.getKaizensExcludeHiddenPaged(this.pageNumber, this.pageSize).subscribe({
        next: (data) => {
          this.kaizens = data.data;
          this.dataSource.data = this.mapToTableView(data.data);
          if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
          }
        },
        error: (error) => console.info(error)
      });
    }
  }

  OnSearch(criteria: string) {
    this.pageNumber = 1;
    if (!criteria) {
      if (this.showHidden) {
        this.kaizenService.getKaizens().subscribe({
          next: (data) => {
            this.kaizens = data.data;
            this.dataSource.data = this.mapToTableView(data.data);
            if (this.dataSource.paginator) {
              this.dataSource.paginator.firstPage();
            }
          },
          error: (error) => console.info(error)
        });
      } else {
        this.kaizenService.getKaizensExcludeHiddenPaged(this.pageNumber, this.pageSize).subscribe({
          next: (data) => {
            this.kaizens = data.data;
            this.dataSource.data = this.mapToTableView(data.data);
            if (this.dataSource.paginator) {
              this.dataSource.paginator.firstPage();
            }
          },
          error: (error) => console.info(error)
        });
      }
    } else {
      this.kaizenService.searchKaizens(criteria, this.showHidden, '').subscribe({
        next: (data) => {
          this.kaizens = data.data;
          this.dataSource.data = this.mapToTableView(data.data);
          if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
          }
        },
        error: (error) => console.info(error)
      });
    }
  }
  
}